<nav class="navbar navbar-expand-lg sticky-top  px-5 mx-4 py-3 shadow" [class.sticky]="isSticky" style="border-radius: 50px;" >
    <div class="container-fluid px-0">
      <div class="d-flex">
        <a class="navbar-brand d-none d-md-block d-lg-block d-xl-block" routerLink="/" >
          <img src="../../../assets/images/DumyUser/touch.png"  style="max-height: 75px;" />
        </a>
        <a class="navbar-brand d-block d-md-none d-lg-none d-xl-none" routerLink="/" >
          <img src="../../../assets/images/DumyUser/touch.png"  style="max-height: 40px;" />
        </a>
      </div>
      <div class="order-lg-3">
        <div class="d-flex align-items-center">
          <div class="pe-3 d-none d-md-block d-lg-block d-xl-block">
            <a href="#" class="form-check form-switch theme-switch btn btn-light btn-icon rounded-circle">
              <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
                [checked]="isDarkTheme" (change)="toggleTheme()" />
              <label class="form-check-label" for="flexSwitchCheckDefault"></label>
            </a>
          </div>

          <button *ngIf="userId !== ''" class="btn btn-dark py-3 me-2 shadow  rounded-4 d-none d-md-block d-lg-block"
            (click)="logOut()">
             {{'LOG_OUT' | translate}}
          </button>
          <a *ngIf="userRole== 'User'" class="btn btn-primary py-3 me-2 shadow  rounded-4 d-none d-md-block d-lg-block"
            routerLink="/ManueDash">
             {{'MY_PROFILE' | translate}}
            </a>
            <a *ngIf="userRole== 'Administrator'" class="btn btn-primary py-3 me-2 shadow  rounded-4 d-none d-md-block d-lg-block"
            routerLink="/Admin">
             {{'ADMIN_PORTAL' | translate}}
          </a>

          <div class="d-none d-md-block d-lg-block d-xl-block" >
            <a routerLink="/login" *ngIf="userId == ''"  class="btn px-4 py-3 btn-lg btn-light me-2 rounded-3">
              {{'LOG_IN' | translate}}
            </a>
            <a *ngIf="userId == ''" routerLink="/register" class="btn shadow btn-lg text-white py-3 px-7 rounded-4 bg-dark">
              {{'SIGN_UP_FREE' | translate}}
            </a>
          </div>
          <div class="d-block d-md-none d-lg-none d-xl-none">
            <a routerLink="/login" *ngIf="userId == ''"  class="btn btn-primary me-2">
              {{'LOG_IN' | translate}}
            </a>

          </div>
          <button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbar-default2" aria-controls="navbar-default2" aria-expanded="false"
            aria-label="Toggle navigation">
            <span class="icon-bar top-bar mt-0"></span>
            <span class="icon-bar middle-bar"></span>
            <span class="icon-bar bottom-bar"></span>
          </button>
        </div>
      </div>
      <!-- Collapse -->
      <div class="collapse navbar-collapse" id="navbar-default2">
        <ul class="navbar-nav" *ngIf="loading">
          <li class="nav-item dropdown dropdown-fullwidth">
            <div class="ms-4 me-2" style="height: 20px;width: 100%;">
              <div class="skeleton-card px-5"  ></div>
            </div>

          </li>

          <li class="nav-item">
            <div class="ms-4 me-2" style="height: 20px;width: 100%;">
              <div class="skeleton-card px-5"  ></div>
           </div>
          </li>
          <li class="nav-item">
            <div class="ms-4 me-2" style="height: 20px;width: 100%;">
              <div class="skeleton-card px-5"  ></div>
           </div>
          </li>
        </ul>

        <ul class="navbar-nav" *ngIf="!loading">
          <li class="nav-item dropdown dropdown-fullwidth pt-2">
            <a class="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" aria-haspopup="true"
              aria-expanded="false">
              Resources <i class="fa fa-angle-down" aria-hidden="true"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-md">
              <div class="px-4 pt-2 pb-2">

                <div class="row" *ngIf="loading">
                  <div class="col-12">
                    <div class="lh-1 mb-5">
                      <div style="height: 80px;">
                        <div class="skeleton-card"></div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-12">
                    <div class="border-bottom pb-2 mb-3">
                      <div style="height: 50px;" class="mt-2">
                        <div class="skeleton-card"></div>
                      </div>
                    </div>
                    <div class="">
                      <a href="#">
                        <div style="height: 50px;" class="mt-2">
                          <div class="skeleton-card"></div>
                        </div>
                      </a>
                      <a href="#">
                        <div style="height: 50px;" class="mt-2">
                          <div class="skeleton-card"></div>
                        </div>
                      </a>
                      <a href="#">
                        <div style="height: 50px;" class="mt-2">
                          <div class="skeleton-card"></div>
                        </div>
                      </a>
                      <a href="#">
                        <div style="height: 50px;" class="mt-2">
                          <div class="skeleton-card"></div>
                        </div>
                      </a>

                    </div>
                  </div>
                  <div class="col-lg-4 col-12 mt-4 mt-lg-0">
                    <div style="height: 80px;">
                      <div class="skeleton-card"></div>
                    </div>
                    <div class="">
                      <a href="#">
                        <div style="height: 50px; " class="mt-2">
                          <div class="skeleton-card"></div>
                        </div>
                      </a>
                      <a href="#">
                        <div style="height: 50px;" class="mt-2">
                          <div class="skeleton-card"></div>
                        </div>
                      </a>
                      <a href="#">
                        <div style="height: 50px;" class="mt-2">
                          <div class="skeleton-card"></div>
                        </div>
                      </a>
                      <a href="#">
                        <div style="height: 50px;" class="mt-2">
                          <div class="skeleton-card"></div>
                        </div>
                      </a>
                      <a href="#">
                        <div style="height: 50px;" class="mt-2">
                          <div class="skeleton-card"></div>
                        </div>
                      </a>

                    </div>
                  </div>
                  <div class="col-lg-4 col-12 mt-4 mt-lg-0">
                    <div class="border-bottom pb-2 mb-3">
                      <div style="height: 50px;">
                        <div class="skeleton-card"></div>
                      </div>
                    </div>
                    <div class="">
                      <ul class="nav flex-column">
                        <li class="nav-item">
                          <a href="#" class="nav-link">
                            <div style="height: 20px;">
                            <div class="skeleton-card">

                            </div>
                          </div></a>
                        </li>
                        <li class="nav-item">
                          <a href="#" class="nav-link">
                            <div style="height: 20px;">
                            <div class="skeleton-card">

                            </div>
                          </div></a>
                        </li>
                        <li class="nav-item">
                          <a href="#" class="nav-link">
                            <div style="height: 20px;">
                            <div class="skeleton-card">

                            </div>
                          </div></a>
                        </li>
                        <li class="nav-item">
                          <a href="#" class="nav-link">
                            <div style="height: 20px;">
                            <div class="skeleton-card">

                            </div>
                          </div></a>
                        </li>
                        <li class="nav-item">
                          <a href="#" class="nav-link">
                            <div style="height: 20px;">
                            <div class="skeleton-card">

                            </div>
                          </div></a>
                        </li>
                        <li class="nav-item">
                          <a href="#" class="nav-link">
                            <div style="height: 20px;">
                            <div class="skeleton-card">

                            </div>
                          </div></a>
                        </li>
                      </ul>

                    </div>
                  </div>
                </div>
                <div class="row" *ngIf="!loading">
                  <div class="col-12">
                    <div class="lh-1 mb-5">
                      <h3 class="mb-1">
                        {{'RESOURCE_CENTER' | translate}}
                      </h3>
                      <p>
                        {{'QUICK_LINKS_ABOUT_COMPANY' | translate}}
                      </p>
                    </div>
                  </div>
                  <div class="col-lg-4 col-12">
                    <div class="border-bottom pb-2 mb-3">
                      <h5 class="mb-0">
                        {{'COMPANY' | translate}}
                      </h5>
                    </div>
                    <div class="">
                      <a [routerLink]="['/CompanyPage',item.id]"  *ngFor="let item of Company">
                        <div class="d-flex mb-3" >
                          <img src="{{item.image}}" alt="" class="avatar shadow rounded-2">
                          <div class="ms-2">
                            <h6>{{item.title}}</h6>
                            <small class="mt-n2 text-truncate d-block" style="max-width: 200px; overflow: hidden; white-space: nowrap;">
                              {{ item.metaDescription }}
                            </small>
                            
                          </div>
                        </div>
                      </a>

                    </div>
                  </div>
                  <div class="col-lg-4 col-12 mt-4 mt-lg-0">
                    <div class="border-bottom pb-2 mb-3">
                      <h5 class="mb-0">
                        {{'RESOURCES' | translate}}
                      </h5>
                    </div>
                    <div class="">
                      <a [routerLink]="['/CompanyPage',item.id]" *ngFor="let item of Resources">
                        <div class="d-flex mb-3" >
                          <img src="{{item.image}}" alt="" class="avatar shadow rounded-2">
                          <div class="ms-2">
                            <h6>{{item.title}}</h6>
                            <small class="mt-n2 text-truncate d-block" style="max-width: 200px; overflow: hidden; white-space: nowrap;">
                              {{ item.metaDescription }}
                            </small>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="col-lg-4 col-12 mt-4 mt-lg-0">
                    <div class="border-bottom pb-2 mb-3">
                      <h5 class="mb-0">
                        {{'SUPPORT' | translate}}
                      </h5>
                    </div>
                    <div class="">
                      <ul class="nav flex-column">
                        <li class="nav-item" *ngFor="let item of Support">
                          <a [routerLink]="['/CompanyPage',item.id]" class="nav-link">{{item.title}}</a>
                        </li>
                      </ul>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li class="nav-item">
            <a class="nav-link mt-2 px-3 ps-4 ms-2  d-flex justify-content-between dropdown-toggle" routerLink="/contact">
              {{'CONTACT_US' | translate}}
              <i class="pi pi-angle-down mt-2 text-white"></i>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link mt-2 px-3 ps-4 ms-2  d-flex justify-content-between dropdown-toggle" routerLink="/showPosts">
               {{'BLOG' | translate}}
              <i class="pi pi-angle-down mt-2 text-white"></i>
            </a>
          </li>
          <select (change)="switchLanguage($event)" class="btn btn-icon btn-light me-2 mt-1">
            <option value="en">En</option>
            <option value="fr">Fr</option>
          </select>
          <li class="nav-item">
            <a *ngIf="userRole== 'User'" class="btn btn-primary my-2 py-3 me-2 shadow  rounded-4 d-block d-md-none d-lg-none"
            routerLink="/touchConnect">
              {{'MY_PROFILE' | translate}}
           </a>
          </li>

          <li class="nav-item">
            <a *ngIf="userRole== 'Administrator'" class="btn btn-primary py-3 my-2 me-2 shadow  rounded-4 d-block d-md-none d-lg-none"
            routerLink="/touchConnect">
             {{'MY_PROFILE' | translate}}
          </a>
          </li>
          <li class="nav-item">
            <a *ngIf="userRole== 'Administrator'" class="btn btn-primary py-3 my-2 me-2 shadow  rounded-4 d-block d-md-none d-lg-none"
             routerLink="/Admin">
              {{'ADMIN_PORTAL' | translate}}
            </a>
          </li>
          <li class="nav-item">
            <a *ngIf="userId !== ''" class="btn btn-dark py-3 my-2 me-2 shadow  rounded-4 d-block d-md-none d-lg-none"
            (click)="logOut()">
             {{'LOG_OUT' | translate}}
          </a>
          </li>
        </ul>
      </div>
    </div>
</nav>


